interface ITerritoriesProduct {
    Name: string;
    THC: string;
    CBD: string;
}
interface ITerritoriesData {
    Format: string;
    Cannabinoid: string;
    CannabinoidText?: string;
    Products: ITerritoriesProduct[];
}

export interface ITerritories {
    Name: string;
    Data: ITerritoriesData[];
}

export const Territories: ITerritories[] = [
    {
        Name: "Germany",
        Data: [
            {
                Format: "Flowers",
                Cannabinoid: "THC+",
                CannabinoidText: "THC / CBD > 10  AND THC ≥25",
                Products: [
                    {
                        Name: "Pedanios 26/1 EHD-CA",
                        THC: "27",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 27/1 BLY-CA",
                        THC: "27",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 27/1 FRG-CA",
                        THC: "27",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 27/1 PND-CA",
                        THC: "27",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 28/1 CMK-CA",
                        THC: "28",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 29/1 SRD-CA",
                        THC: "29",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 31/1 CMK-CA",
                        THC: "31",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 31/1 COS-CA",
                        THC: "31",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 31/1 PND-CA",
                        THC: "31",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10  AND THC<25",
                Products: [
                    {
                        Name: "Aurora 20/1",
                        THC: "20",
                        CBD: "1"
                    },
                    {
                        Name: "Aurora 22/1",
                        THC: "22",
                        CBD: "1"
                    },
                    {
                        Name: "Aurora 24/1 PNK-CA",
                        THC: "24",
                        CBD: "1"
                    },
                    {
                        Name: "Indimed 20/1 ISS - DE",
                        THC: "20",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 18/1 TNG-CA",
                        THC: "18",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 20/1",
                        THC: "20",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 20/1 GTH-CA",
                        THC: "20",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 22/1",
                        THC: "22",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 24/1 LAC-CA",
                        THC: "24",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: [
                    {
                        Name: "Pedanios 10/10 EQI-CA",
                        THC: "10",
                        CBD: "10"
                    },
                    {
                        Name: "Pedanios 10/13 MBE-CA",
                        THC: "10",
                        CBD: "13"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "CBD",
                CannabinoidText: "THC / CBD < 0.25",
                Products: [
                    {
                        Name: "Aurora 1/16 VSP-CA",
                        THC: "1",
                        CBD: "16"
                    }
                ]
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC",
                CannabinoidText:"THC / CBD > 10",
                Products: [
                    {
                        Name: "Aurora Extract 25:1",
                        THC: "25",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD",
                CannabinoidText:"THC / CBD = 0.25 - 10",
                Products: [
                    {
                        Name: "Aurora Extract 12.5:12.5",
                        THC: "12.5",
                        CBD: "12.5"
                    },
                    {
                        Name: "Aurora Extract 50:50",
                        THC: "50",
                        CBD: "50"
                    }
                ]
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD+",
                CannabinoidText: "THC / CBD < 0.25",
                Products: [
                    {
                        Name: "Aurora Extract 10:100",
                        THC: "10",
                        CBD: "100"
                    }
                ]
            }
        ]
    },
    {
        Name: "Australia",
        Data: [
            {
                Format: "Flowers",
                Cannabinoid: "THC+",
                CannabinoidText: "THC / CBD > 10  AND THC ≥25",
                Products: [
                    {
                        Name: "Aurora Chemango Kush",
                        THC: "29",
                        CBD: "1"
                    },
                    {
                        Name: "Craftplant Cosmic Cream",
                        THC: "32",
                        CBD: "1"
                    },
                    {
                        Name: "Craftplant Pink Diesel",
                        THC: "28",
                        CBD: "1"
                    },
                    {
                        Name: "Scraftplant Navana (Sourdough)",
                        THC: "29",
                        CBD: "1"
                    },
                    {
                        Name: "Aurora Black Jelly",
                        THC: "28",
                        CBD: "1"
                    },
                    {
                        Name: "Craftplant Greendae (Farm Gas)",
                        THC: "29",
                        CBD: "1"
                    },
                    {
                        Name: "Craftplant HiVolt (Electric Honeydew)",
                        THC: "25",
                        CBD: "1"
                    },
                    {
                        Name: "Craftplant Hivolt",
                        THC: "25",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10  AND THC<25",
                Products: [
                    {
                        Name: "IndiMed 19 Indica (Pink Kush)",
                        THC: "19",
                        CBD: "1"
                    },
                    {
                        Name: "IndiMed 19 Sativa (Luminarium)",
                        THC: "19",
                        CBD: "1"
                    },
                    {
                        Name: "IndiMed 19 Indica (Bubba Kush)",
                        THC: "19",
                        CBD: "1"
                    },
                    {
                        Name: "IndiMed 26 Farm Gas",
                        THC: "26",
                        CBD: "1"
                    },
                    {
                        Name: "IndiMed 26 Sourdough",
                        THC: "26",
                        CBD: "1"
                    },
                    {
                        Name: "IndiMed 26 Electric Honeydew",
                        THC: "26",
                        CBD: "1"
                    },
                    {
                        Name: "IndiMed 22 Pickled Petrol",
                        THC: "22",
                        CBD: "1"
                    },
                    {
                        Name: "IndiMed 22 Lemon Laser",
                        THC: "22",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: [
                    {
                        Name: "Moon Berry",
                        THC: "10",
                        CBD: "13"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "CBD",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10",
                Products: [
                    {
                        Name: "Aurora/IndiMed Extract 25:1 (Indica)",
                        THC: "25",
                        CBD: "1"
                    },
                    {
                        Name: "Aurora/IndiMed Extract 25:1 (Sativa)",
                        THC: "25",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: [
                    {
                        Name: "Aurora/IndiMed Extract 12.5:12.5",
                        THC: "12.5",
                        CBD: "12.5"
                    },
                    {
                        Name: "Aurora/IndiMed Extract 50:50",
                        THC: "50",
                        CBD: "50"
                    }
                ]
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD+",
                CannabinoidText: "THC / CBD < 0.25",
                Products: [
                    {
                        Name: "Aurora/IndiMed Extract 10:100",
                        THC: "10",
                        CBD: "100"
                    },
                    {
                        Name: "Aurora/IndiMed CBD ISO 100 (externally produced)",
                        THC: "0",
                        CBD: "100"
                    }
                ]
            }
        ]
    },
    {
        Name: "Canada",
        Data: [
            {
                Format: "Flowers",
                Cannabinoid: "THC+",
                CannabinoidText: "THC / CBD > 10  AND THC ≥25",
                Products: [
                    {
                        Name: "Chemango Kush",
                        THC: "27",
                        CBD: "0.1"
                    },
                    {
                        Name: "Specialty #3-Farm Gas",
                        THC: "26",
                        CBD: "0.1"
                    },
                    {
                        Name: "Luminarium",
                        THC: "26",
                        CBD: "1.1"
                    },
                    {
                        Name: "Garlic Bread",
                        THC: "31.2",
                        CBD: "1.1"
                    },
                    {
                        Name: 'Electric Honeydew',
                        THC: "28",
                        CBD: "0.1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10  AND THC<25",
                Products: [
                    {
                        Name: "Sedamen",
                        THC: "23",
                        CBD: "0.1"
                    },
                    {
                        Name: "Rex",
                        THC: "12",
                        CBD: "0.1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: [
                    {
                        Name: "Moon Berry or Equiberry",
                        THC: "5-11'",
                        CBD: "7-14`"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "CBD",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10",
                Products: [
                    {
                        Name: "THC Drops (Indica)",
                        THC: "21",
                        CBD: "0"
                    },
                    {
                        Name: "THC Drops (Sativa)",
                        THC: "21",
                        CBD: "0"
                    },
                    {
                        Name: "Luminarium",
                        THC: "21.9",
                        CBD: "0"
                    },
                    {
                        Name: "Sedamen",
                        THC: "21.9",
                        CBD: "0"
                    }
                ]
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: [
                    {
                        Name: "1:1 Drops (Indica) ",
                        THC: "16.8",
                        CBD: "16.8"
                    },
                    {
                        Name: "1:1 Drops (Sativa)",
                        THC: "16.8",
                        CBD: "16.8"
                    },
                    {
                        Name: "CanniMed Oil 10:10",
                        THC: "10.8",
                        CBD: "10.8"
                    }
                ]
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD+",
                CannabinoidText: "THC / CBD < 0.25",
                Products: [
                    {
                        Name: "CBD Drops",
                        THC: "0",
                        CBD: "27.4"
                    },
                    {
                        Name: "CanniMed Oil 1:20",
                        THC: "0",
                        CBD: "21.7"
                    },
                    {
                        Name: "Vespera",
                        THC: "1.7",
                        CBD: "30.7"
                    },
                    {
                        Name: "Hemplixir 100 CBD Oil ",
                        THC: "1",
                        CBD: "95.8"
                    },
                    {
                        Name: "Avidekel Oil",
                        THC: "0",
                        CBD: "28.6"
                    }
                ]
            }
        ]
    },
    {
        Name: "Czech Republic",
        Data: [
            {
                Format: "Flowers",
                Cannabinoid: "THC+",
                CannabinoidText: "THC / CBD > 10  AND THC ≥25",
                Products: []
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10  AND THC<25",
                Products: [
                    {
                        Name: "Pedanios 22/1",
                        THC: "22",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: [
                    {
                        Name: "Pedanios 10/13 MBE-CA",
                        THC: "10",
                        CBD: "13"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "CBD",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD+",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            }
        ]
    },
    {
        Name: "Malta",
        Data: [
            {
                Format: "Flowers",
                Cannabinoid: "THC+",
                CannabinoidText: "THC / CBD > 10  AND THC ≥25",
                Products: [
                    {
                        Name: "Pedanios 29/1 SRD-CA",
                        THC: "29",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 27/1 FRG-CA",
                        THC: "27",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10  AND THC<25",
                Products: [
                    {
                        Name: "Pedanios 22/1",
                        THC: "22",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: []
            },
            {
                Format: "Flowers",
                Cannabinoid: "CBD",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD+",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            }
        ]
    },
    {
        Name: "New Zealand",
        Data: [
            {
                Format: "Flowers",
                Cannabinoid: "THC+",
                CannabinoidText: "THC / CBD > 10  AND THC ≥25",
                Products: []
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10  AND THC<25",
                Products: [
                    {
                        Name: "Sedaprem",
                        THC: "21.3",
                        CBD: "0-1"
                    },
                    {
                        Name: "Luminarium",
                        THC: "22.5",
                        CBD: "0-1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: [
                    {
                        Name: "Equiposa",
                        THC: "9",
                        CBD: "8.3"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "CBD",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD+",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            }
        ]
    },
    {
        Name: "Poland",
        Data: [
            {
                Format: "Flowers",
                Cannabinoid: "THC+",
                CannabinoidText: "THC / CBD > 10  AND THC ≥25",
                Products: [
                    {
                        Name: "Cannabis flos Aurora THC 29% CBD </= 1%",
                        THC: "29",
                        CBD: "1"
                    },
                    {
                        Name: "Cannabis flos Aurora THC 27% CBD </= 1%",
                        THC: "27",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10  AND THC<25",
                Products: [
                    {
                        Name: "Cannabis flos Aurora THC 22% CBD </= 1%",
                        THC: "22",
                        CBD: "1"
                    },
                    {
                        Name: "Cannabis flos Aurora Deutschland GmbH THC 22% CBD </= 1%",
                        THC: "22",
                        CBD: "1"
                    },
                    {
                        Name: "Cannabis flos Aurora THC 20% CBD </= 1%",
                        THC: "20",
                        CBD: "1"
                    },
                    {
                        Name: "Cannabis flos Aurora Deutschland GmbH THC 20% CBD </= 1%",
                        THC: "20",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: [
                    {
                        Name: "Cannabis flos Aurora Deutschland GmbH THC 8% CBD 8%",
                        THC: "8",
                        CBD: "8"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "CBD",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD+",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            }
        ]
    },
    {
        Name: "UK",
        Data: [
            {
                Format: "Flowers",
                Cannabinoid: "THC+",
                CannabinoidText: "THC / CBD > 10  AND THC ≥25",
                Products: [
                    {
                        Name: "Pedanios 31/1 CMK-CA",
                        THC: "31",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 31/1 COS-CA",
                        THC: "31",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 31/1 PND-CA",
                        THC: "31",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 29/1 SRD-CA",
                        THC: "29",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 28/1 CMK-CA",
                        THC: "28",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 27/1 PND-CA",
                        THC: "27",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 27/1 BLY-CA",
                        THC: "27",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 27/1 FRG-CA",
                        THC: "27",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 26/1 EHD-CA",
                        THC: "26",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10  AND THC<25",
                Products: [
                    {
                        Name: "Aurora 24/1 PNK-CA",
                        THC: "24",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 24/1 LAC-CA",
                        THC: "24",
                        CBD: "1"
                    },
                    {
                        Name: "Aurora 22/1",
                        THC: "22",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 22/1",
                        THC: "22",
                        CBD: "1"
                    },
                    {
                        Name: "Aurora 20/1",
                        THC: "20",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 20/1",
                        THC: "20",
                        CBD: "1"
                    },
                    {
                        Name: "Pedanios 18/1 TNG-CA",
                        THC: "18",
                        CBD: "1"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: [
                    {
                        Name: "Pedanios 10/10 EQI-CA",
                        THC: "10",
                        CBD: "10"
                    },
                    {
                        Name: "Pedanios 10/13 MBE-CA",
                        THC: "10",
                        CBD: "13"
                    }
                ]
            },
            {
                Format: "Flowers",
                Cannabinoid: "CBD",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC",
                CannabinoidText: "THC / CBD > 10",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD",
                CannabinoidText: "THC / CBD = 0.25 - 10",
                Products: []
            },
            {
                Format: "Extracts",
                Cannabinoid: "THC/CBD+",
                CannabinoidText: "THC / CBD < 0.25",
                Products: []
            }
        ]
    }

]
